const mEditionAssetInvitationsModalCreate = {
  mEditionAssetInvitationsModalCreate: {
    alerts: {
      createInscripcion: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La acción fue procesada exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ENVIAR',

    inputs: {
      email: {
        label: 'Emails de Nuevos Alumnos',
        placeholder: 'Escribe aquí un email y presiona enter',
        tooltip: 'Si el o los alumnos ya pertenecen a la academia serán inscriptos en el curso, caso contrario sus inscripciones serán habilitadas una vez que confirmen las invitaciones.'
      }
    },

    title: 'Enviar Invitación',

    validation: {
      email: {
        email: 'El email ingresado no es una cuenta válida.',
        required: 'Email de nuevo alumno es requerido.',
        invalid: 'Las siguientes casillas de correo no son válidas:',
        others: 'Y otras',
        more: 'casillas...'
      }
    }
  }
}

export default mEditionAssetInvitationsModalCreate
